export default "__VITE_ASSET__46960a93__"